import { Injectable, inject } from '@angular/core';
import { FaceLandmarker, ImageEmbedder, ObjectDetector } from '@mediapipe/tasks-vision';
import { BehaviorSubject, Observable } from 'rxjs';
import { PolTimerManagerService } from './pol/timer-manager.service';
import { OcrTimerManagerService } from './ocr/timer-manager.service';

@Injectable({
	providedIn: 'root',
})
export class ProcessHelperService {
	private polTimerManagerService = inject(PolTimerManagerService);
	private ocrTimerManagerService = inject(OcrTimerManagerService);

	private $documentModel: BehaviorSubject<ObjectDetector> = new BehaviorSubject<ObjectDetector>(null);
	private $openCV: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	private $faceModel: BehaviorSubject<FaceLandmarker> = new BehaviorSubject<FaceLandmarker>(null);
	private $imageEmbedderModel: BehaviorSubject<ImageEmbedder> = new BehaviorSubject<ImageEmbedder>(null);

	public getDocumentModel(): Observable<ObjectDetector> {
		return this.$documentModel.asObservable();
	}

	public setDocumentModel(value: ObjectDetector): void {
		this.$documentModel.next(value);
	}

	public getOpenCV(): Observable<any> {
		return this.$openCV.asObservable();
	}

	public setOpenCV(value: any): void {
		this.$openCV.next(value);
	}

	public getFaceModel(): Observable<FaceLandmarker> {
		return this.$faceModel.asObservable();
	}

	public setFaceModel(value: FaceLandmarker): void {
		this.$faceModel.next(value);
	}

	public getImageEmbedderModel(): Observable<ImageEmbedder> {
		return this.$imageEmbedderModel.asObservable();
	}

	public setImageEmbedderModel(value: ImageEmbedder): void {
		this.$imageEmbedderModel.next(value);
	}

	public stopAllOperationsTimers(): void {
		this.ocrTimerManagerService.stopAllTimers();
		this.polTimerManagerService.stopAllTimers();
	}
}
